import { render } from "./CollabConversationCard.vue?vue&type=template&id=2a9bf147"
import script from "./CollabConversationCard.vue?vue&type=script&lang=js"
export * from "./CollabConversationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__